import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'

import { API_ENDPOINTS } from '../../../common/apiEndpoints'
import {
  ConfirmOperationResponseSchema,
  ErrorResponse,
  ExecuteAddTenant,
} from '../../../common/validations'
import { ResidentAppError } from '../../../common/error'
import { getContractQueryKey } from './useAPIGetContract'
import { getContractsQueryKey } from './useAPIGetContracts'

import { post } from 'api/apiClient'

export const useAPIExecuteModificationAddTenant = (
  contractUUID: string,
  locale: string,
  options?: UseMutationOptions<
    { success: boolean },
    ErrorResponse,
    Omit<ExecuteAddTenant, 'locale'>
  >
) => {
  const queryClient = useQueryClient()
  const { onSuccess, ...mutationOptions } = options ?? {}

  const { mutate, isSuccess, isError, data, isPending } = useMutation({
    mutationFn: ({ operationData }) =>
      post(
        `${API_ENDPOINTS.CONTRACTS}/${contractUUID}/confirm-operation/add-tenant`,
        {
          operationData,
          locale,
        },
        ConfirmOperationResponseSchema
      ),
    ...mutationOptions,
    onSuccess: async (response, variables, onMutateResult, context) => {
      await queryClient.invalidateQueries({
        queryKey: getContractsQueryKey(),
        exact: true,
      })
      await queryClient.invalidateQueries({
        queryKey: getContractQueryKey(contractUUID),
      })

      if (onSuccess) {
        await onSuccess(response, variables, onMutateResult, context)
      }
    },
  })

  if (isError) {
    throw ResidentAppError.ClientError('ADD_TENANT_INIT_CONFIRM_ERROR')
  }

  return {
    mutate,
    isSuccess,
    data,
    isPending,
  }
}
